/* eslint-disable no-console */
import { startPerfSpan, verboseLogPerfSpanEnd } from './userExtAnalytics/bugsnag';

const PERF_LOG_MAX_SEC = 5;
const PERF_LOG_MIN_CONSOLE_SEC = 0.5; // в консоль выводятся только замеры >= 0.5 с (в Bugsnag уходят все)
// Градиент: оранжевый (0s) → красный (5s)
const PERF_COLOR_ORANGE = [249, 115, 22]; // #f97316
const PERF_COLOR_RED = [220, 38, 38];     // #dc2626

function lerp(a, b, t) {
  return Math.round(a + (b - a) * Math.max(0, Math.min(1, t)));
}

function perfLogStyle(sec) {
  if (sec < 0.1) return 'color: #999; font-weight: 500';
  const t = Math.min(sec / PERF_LOG_MAX_SEC, 1);
  const r = lerp(PERF_COLOR_ORANGE[0], PERF_COLOR_RED[0], t);
  const g = lerp(PERF_COLOR_ORANGE[1], PERF_COLOR_RED[1], t);
  const b = lerp(PERF_COLOR_ORANGE[2], PERF_COLOR_RED[2], t);
  return `color: rgb(${r},${g},${b}); font-weight: 600`;
}

function isErrorLike(val) {
  return val instanceof Error || (typeof val === 'object' && val !== null && (val.message != null || val.stack != null));
}

const log = {
  error(a, b) {
    let descriptor = '';
    let err = null;

    if (b !== undefined && b !== null && isErrorLike(b)) {
      descriptor = typeof a === 'string' ? a : '';
      err = b;
    } else if (typeof a === 'string') {
      descriptor = a;
    } else if (a !== undefined && a !== null && isErrorLike(a)) {
      err = a;
    }
    if (descriptor) console.error(descriptor);
    if (err) console.error(err);
    if (err) {
      import('./userExtAnalytics/bugsnag').then(m => {
        if (typeof m.notifyErrorSafely === 'function') {
          m.notifyErrorSafely(err);
        }
      });
    }
  },
  time(spanName) {
    const t0 = performance.now();
    const span = typeof startPerfSpan === 'function' ? startPerfSpan(spanName) : null;

    return {
      end() {
        try {
          const secNum = (performance.now() - t0) / 1000;
          const sec = secNum.toFixed(3);

          if (span) {
            if (span.setAttribute) span.setAttribute('perf.duration_sec', secNum);
            verboseLogPerfSpanEnd(spanName, Math.round(secNum * 1000));
            if (span.end) span.end();
          }
          if (secNum >= PERF_LOG_MIN_CONSOLE_SEC) {
            console.log(`%c[perf] ${spanName}, ${sec}s`, perfLogStyle(secNum));
          }
        } catch (e) {
          console.error('[log.time] end failed', spanName, e);
        }
      },
    };
  },
};

export default log;
export { log };
